import React, { useState } from 'react';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import '../styles/SectionConnexion.scss';
import envelope from '../assets/envelope.svg';
import { useTranslation } from 'react-i18next';

function GroupingForgotPassword({ handleClick }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showError, setShowError] = useState('');
  const { t } = useTranslation();

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleInputChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setShowError('');
    setSuccessMessage('');

    if (value && !emailRegex.test(value)) {
      setError(t('auth.invalidEmail'));
    } else {
      setError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setError(t('auth.emailRequired'));
      return;
    }
    if (!emailRegex.test(email)) {
      setError(t('auth.invalidEmailAddress'));
      return;
    }

    setIsSubmitting(true);
    setShowError('');
    setSuccessMessage('');

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/gotoemail`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const result = await response.json();
      if (result.status === 0) {
        setSuccessMessage(t('auth.resetEmailSent'));
        setEmail('');
        setError('');
      } else {
        setShowError(t('auth.emailNotFound'));
      }
    } catch (err) {
      setShowError(t('auth.connectionError'));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className='GroupingConnexion'>
      {showError !== '' &&
        <div className='GroupingConnexionErrors'>
          {showError}
        </div>
      }
      {successMessage !== '' &&
        <div className='resetSuccess'>
          {successMessage}
        </div>
      }
      <h4>
        <span>{t('auth.forgotPasswordSubtitle')}</span>
      </h4>
      <div>
        <Form className='modal-body-form' onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="forgotEmail">
            <FloatingLabel controlId="floatingForgotEmail" label={t('auth.email')} className="mb-3">
              <span className='form-floating-blueMagic'></span>
              <Form.Control
                type="email"
                placeholder={t('auth.email')}
                value={email}
                onChange={handleInputChange}
                isInvalid={!!error}
              />
              <img src={envelope} alt='envelope' />
              <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>
          <Button type="submit" disabled={isSubmitting}>
            {!isSubmitting ? <span>{t('auth.sendResetLink')}</span> : <span className="spinner-border text-light" role="status"></span>}
          </Button>
        </Form>
      </div>
      <div className='queryConnexion'>
        <span className='queryConnexion2' onClick={handleClick}>{t('auth.backToLogin')}</span>
      </div>
    </div>
  );
}

export default GroupingForgotPassword;
